module.exports = __webpack_public_path__ + "static/img/dalianligong.7b1166e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ggw_img/dalianligong.jpg
// module id = 4wr8
// module chunks = 36